module.exports = __webpack_public_path__ + "img/Differentiation-OVCA_10X_WTA.79412e6c.png";